<template>
  <!-- banner部分 -->
  <div class="swiper-banner" ref="mySwiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(m,index) in index_banner" v-bind:key="index">
        <router-link :to="m.url">
          <img :src="m.img" :alt="m.title" :title="m.title"/>
        </router-link>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  <!-- 最新要闻 -->
  <div class="hot-news">
    <div class="container-box hot-box">
      <div class="left">最新要闻</div>
      <div class="right" v-if="latestNews">
        <a @click.prevent="goToDetail(latestNews)">
          <h2 class="title">{{ latestNews.title }}</h2>
          <div class="summary" v-html="latestNews.content"></div>
        </a>
      </div>
    </div>
  </div>
  <!-- 课研公告/协会新闻 -->
  <div class="news-tabs-section">
    <div class="gk-container">
      <div class="news-content-wrapper">
        <!-- 左侧大图 -->
        <div class="news-left">
          <div class="featured-news" v-if="latestNews">
            <a @click.prevent="goToDetail(latestNews)">
              <div class="featured-image">
                <img :src="latestNews.img && latestNews.img[0]" :alt="latestNews.title">
                <div class="time-badge">{{ formatDate(latestNews.create_time) }}</div>
              </div>
              <div class="featured-title">
                {{ latestNews.title }}
              </div>
              <div class="featured-desc" v-html="latestNews.content">
              </div>
            </a>
          </div>
        </div>
        
        <!-- 右侧选项卡 -->
        <div class="news-right">
          <div class="news-tabs">
            <div class="tabs-header">
              <div class="tab-item" :class="{active: activeTab === 'notice'}" @click="activeTab = 'notice'">
                课研公告
              </div>
              <div class="tab-item" :class="{active: activeTab === 'news'}" @click="activeTab = 'news'">
                协会新闻
              </div>
            </div>
            <div class="tabs-content">
              <div class="tab-pane" v-show="activeTab === 'notice'">
                <ul class="news-list">
                  <li v-for="(item, index) in noticeList" :key="index">
                    <a @click.prevent="item.id ? goToDetail(item) : null" :href="item.url">
                      <span class="news-title">{{ item.title }}</span>
                      <span class="news-date">{{ formatDate(item.date) }}</span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="tab-pane" v-show="activeTab === 'news'">
                <ul class="news-list">
                  <li v-for="(item, index) in newsList" :key="index">
                    <a @click.prevent="item.id ? goToDetail(item) : null" :href="item.url">
                      <span class="news-title">{{ item.title }}</span>
                      <span class="news-date">{{ formatDate(item.date) }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 会员服务 -->
  <div class="member-service-section">
    <div class="gk-container">
      <div class="member-right">
        <div class="member-card">
          <router-link to="/service">
            <div class="card-left">
              <h3>入会指南</h3>
              <p class="en-text">Membership guide</p>
            </div>
            <div class="card-right">
              <img src="@/assets/images/member1.jpg" alt="入会指南" class="card-icon">
            </div>
          </router-link>
        </div>
        
        <div class="member-card">
          <router-link to="/service">
            <div class="card-left">
              <h3>会员注册</h3>
              <p class="en-text">Membership application</p>
            </div>
            <div class="card-right">
              <img src="@/assets/images/member2.jpg" alt="会员注册" class="card-icon">
            </div>
          </router-link>
        </div>
        
        <div class="member-card">
          <router-link to="/expert">
            <div class="card-left">
              <h3>会员查询</h3>
              <p class="en-text">Membership inquiry</p>
            </div>
            <div class="card-right">
              <img src="@/assets/images/member3.jpg" alt="会员查询" class="card-icon">
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <!-- 协会介绍 -->
  <div class="association-intro-section">
    <div class="gk-container">
      <div class="intro-content">
        <div class="intro-left">
          <h2 class="section-title">
            <span class="title-text">
              协会介绍
              <span class="en-subtitle">Association Introduction</span>
            </span>
            <router-link to="/introduction" class="more-btn-mobile">
              查看更多 >
            </router-link>
          </h2>
          <div class="intro-text" v-html="profileContent || '山东省心理咨询行业协会由济宁医学院牵头，联合山东省精神卫生中心、山东省戴庄医院、山东中医药大学、曲阜师范大学,山东省立医院、山东第一医科大学、济宁学院共八家学术单位共同发起，于2018年4月2日获山东省民政厅于核准使用该名称并经过一年多的精心筹备和组织工作，完善各项备案材料后于2019年7月1日获得山东省民政厅社会组织管理局批准，同意召开成立大会。'"></div>
          <div class="intro-cards">
            <div class="intro-card" @click="$router.push('/introduction')">
              <div class="card-icon">
                <img src="@/assets/images/about-icon1.png" alt="协会介绍">
              </div>
              <h3 class="card-title">协会介绍</h3>
              <p class="card-subtitle">Introduction</p>
              <p class="card-desc">Social Responsibility</p>
            </div>
            <div class="intro-card" @click="$router.push('/introduction')">
              <div class="card-icon">
                <img src="@/assets/images/about-icon2.png" alt="协会章程">
              </div>
              <h3 class="card-title">协会章程</h3>
              <p class="card-subtitle">Association Charter</p>
              <p class="card-desc">Social Responsibility</p>
            </div>
            <div class="intro-card" @click="$router.push('/introduction')">
              <div class="card-icon">
                <img src="@/assets/images/about-icon3.png" alt="社会责任">
              </div>
              <h3 class="card-title">社会责任</h3>
              <p class="card-subtitle">Social Responsibility</p>
              <p class="card-desc">Social Responsibility</p>
            </div>
          </div>
        </div>
        <div class="intro-right">
          <router-link to="/introduction" class="more-btn">
            查看更多 >
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <!-- 教育培训/政策法规 -->
  <div class="education-policy-section">
    <div class="gk-container">
      <div class="section-wrapper">
        <!-- 教育培训 -->
        <div class="section-item">
          <div class="section-header">
            <h3 class="section-title">教育培训</h3>
            <router-link to="/training" class="more-link">查看更多 ></router-link>
          </div>
          <div class="section-content">
            <ul class="content-list">
              <li v-for="(item, index) in trainingList" :key="index">
                <a @click.prevent="goToDetail(item)">
                  <span class="list-icon">◇</span>
                  <span class="list-title">{{ item.title }}</span>
                  <span class="list-date">{{ item.create_time || item.date }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <!-- 政策法规 -->
        <div class="section-item">
          <div class="section-header">
            <h3 class="section-title">政策法规</h3>
            <router-link to="/documents" class="more-link">查看更多 ></router-link>
          </div>
          <div class="section-content">
            <ul class="content-list">
              <li v-for="(item, index) in policyList" :key="index">
                <a @click.prevent="goToDetail(item)">
                  <span class="list-icon">◇</span>
                  <span class="list-title">{{ item.title }}</span>
                  <span class="list-date">{{ item.create_time || item.date }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 咨询师查询 -->
  <div class="consultant-section">
    <div class="gk-container">
      <div class="section-header">
        <h2 class="section-title">
          咨询师查询
          <span class="en-subtitle">Consultant Inquiry</span>
        </h2>
        <router-link to="/expert" class="more-btn">
          查看更多 >
        </router-link>
      </div>
      
      <div class="consultant-list" v-if="consultantList.length > 0">
        <transition-group name="slide" tag="div" class="consultant-wrapper">
          <div 
            class="consultant-card" 
            v-for="consultant in consultantList" 
            :key="consultant.id"
            @click="goToConsultantDetail(consultant.id)"
          >
            <div class="consultant-avatar">
              <img 
                :src="consultant.photo || consultant.avatar || 'https://picsum.photos/160/160?random=' + consultant.id" 
                :alt="consultant.name"
                @error="handleImageError"
              >
            </div>
            <div class="consultant-info">
              <h3 class="consultant-name">{{ consultant.name || '未知' }}</h3>
              <p class="consultant-title">{{ consultant.title || consultant.position || '心理咨询师' }}</p>
            </div>
            <p class="consultant-desc">
              {{ consultant.intro ||  '暂无简介' }}
            </p>
          </div>
        </transition-group>
      </div>
      <div v-else class="consultant-empty">
        <p>暂无咨询师数据</p>
      </div>
      
      <div class="consultant-nav" v-if="totalPages > 1">
        <button 
          class="nav-arrow nav-prev" 
          @click="prevPage"
          :disabled="currentPage <= 1 || isSliding"
          :class="{ disabled: currentPage <= 1 || isSliding }"
        ></button>
        <div class="page-indicator">
          <span class="current-page">{{ currentPage }}</span>
          <span class="separator">/</span>
          <span class="total-pages">{{ totalPages }}</span>
        </div>
        <button 
          class="nav-arrow nav-next" 
          @click="nextPage"
          :disabled="currentPage >= totalPages || isSliding"
          :class="{ disabled: currentPage >= totalPages || isSliding }"
        ></button>
      </div>
    </div>
  </div>


</template>
<script>
import sys from "@/api/system";
import sysApi from "@/api/index";
import article from "@/api/article";
import "swiper/swiper-bundle.min.css";
import Swiper, {Navigation, Pagination, Autoplay} from "swiper";

Swiper.use([Autoplay, Navigation, Pagination]);

export default {
  name: "index",
  components: {},
  data() {
    return {
      index_banner: [],
      type_data: [],
      data_list: [],
      cid: 0,
      loading: false,
      activeTab: 'notice',
      noticeList: [],
      newsList: [],
      consultantList: [],
      allConsultants: [], // 所有咨询师数据
      currentPage: 1, // 当前页码
      pageSize: 4, // 每页显示数量
      totalPages: 0, // 总页数
      isSliding: false, // 是否正在滑动
      profileContent: '', // 协会介绍内容
      trainingList: [], // 教育培训列表
      policyList: [], // 政策法规列表
      latestNews: null // 最新要闻数据
    }
  },
  created() {
    this.getAdList();
    this.getCategoryNameList();
    this.getIndexList();
    this.getConsultantList();
    this.getProfileContent();
    this.getTrainingList();
    this.getPolicyList();
    this.getLatestNews();
    this.getNoticeList();
    this.getNewsList();
  },
  mounted() {

  },
  methods: {
    //轮播图 banner
    getAdList() {
      sys.getAdList({
        position: 'index_banner'
      }).then(res => {
        if (res) {
          this.index_banner = res.data;
        } else {
          console.log(res);
        }
      })
    },
    //首页 分类选项卡
    getCategoryNameList() {
      article.getCategoryNameList({
        ident: 'news'
      }).then(res => {
        if (res) {
          this.type_data = res.data;
        }
      })
    },
    //切换 类型 选项卡
    typeChange(cid) {
      this.cid = cid;
      this.getIndexList()
    },
    //调取 首页数据
    getIndexList() {
      this.loading = true
      article.getListRowByCid({
        cid: this.cid
      }).then(res => {
        if (res) {
          this.loading = false
          var arr = res.data.map(item=>{
            item.tags = item.tags.split('；');
            return item
          })
          this.data_list = arr;
        } else {
          console.log(res);
        }
      })
    },
    //获取咨询师列表
    getConsultantList() {
      sysApi.publicList({
        page: 1,
        limit: 100 // 获取更多数据用于分页
      }).then(res => {
        if (res && res.code === 2000) {
          // 保存所有数据
          this.allConsultants = res.data?.data || res.data?.list || res.data || [];
          // 计算总页数
          this.totalPages = Math.ceil(this.allConsultants.length / this.pageSize);
          // 显示第一页数据
          this.updateConsultantList();
        }
      }).catch(err => {
        console.log('获取咨询师列表失败:', err);
        this.allConsultants = [];
        this.consultantList = [];
      })
    },
    //获取协会介绍内容
    getProfileContent() {
      sysApi.getDetailByIdent({
        ident: 'profile'
      }).then(res => {
        if (res && res.code === 2000) {
          // 假设返回的数据结构中包含 content 字段
          this.profileContent = res.data?.content || res.data?.intro || '';
        }
      }).catch(err => {
        console.log('获取协会介绍失败:', err);
      })
    },
    //获取教育培训列表
    getTrainingList() {
      sysApi.getTopList({
        cid: 35
      }).then(res => {
        if (res && res.code === 2000) {
          // 获取数据并限制最多显示4条
          const data = res.data?.data || res.data?.list || res.data || [];
          this.trainingList = data.slice(0, 4);
        }
      }).catch(err => {
        console.log('获取教育培训列表失败:', err);
        this.trainingList = [];
      })
    },
    //获取政策法规列表
    getPolicyList() {
      sysApi.getTopList({
        cid: 23
      }).then(res => {
        if (res && res.code === 2000) {
          // 获取数据并限制最多显示4条
          const data = res.data?.data || res.data?.list || res.data || [];
          this.policyList = data.slice(0, 4);
        }
      }).catch(err => {
        console.log('获取政策法规列表失败:', err);
        this.policyList = [];
      })
    },
    //获取最新要闻
    getLatestNews() {
      sysApi.getDetailByIdent({
        ident: 'latestNews'
      }).then(res => {
        if (res && res.code === 2000) {
          this.latestNews = res.data;
        }
      }).catch(err => {
        console.log('获取最新要闻失败:', err);
        this.latestNews = null;
      })
    },
    //获取课研公告列表
    getNoticeList() {
      sysApi.getTopList({
        cid: 18,
        limit: 4
      }).then(res => {
        if (res && res.code === 2000) {
          const data = res.data?.data || res.data?.list || res.data || [];
          this.noticeList = data.slice(0, 4).map(item => ({
            title: item.title,
            date: item.create_time || item.date,
            url: item.url || '#',
            id: item.id
          }));
        }
      }).catch(err => {
        console.log('获取课研公告列表失败:', err);
        this.noticeList = [];
      })
    },
    //获取协会新闻列表
    getNewsList() {
      sysApi.getTopList({
        cid: 19,
        limit: 4
      }).then(res => {
        if (res && res.code === 2000) {
          const data = res.data?.data || res.data?.list || res.data || [];
          this.newsList = data.slice(0, 4).map(item => ({
            title: item.title,
            date: item.create_time || item.date,
            url: item.url || '#',
            id: item.id
          }));
        }
      }).catch(err => {
        console.log('获取协会新闻列表失败:', err);
        this.newsList = [];
      })
    },
    // 更新当前页显示的咨询师列表
    updateConsultantList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.consultantList = this.allConsultants.slice(start, end);
    },
    // 上一页
    prevPage() {
      if (this.isSliding || this.currentPage <= 1) return;
      this.isSliding = true;
      this.currentPage--;
      this.updateConsultantList();
      setTimeout(() => {
        this.isSliding = false;
      }, 500);
    },
    // 下一页
    nextPage() {
      if (this.isSliding || this.currentPage >= this.totalPages) return;
      this.isSliding = true;
      this.currentPage++;
      this.updateConsultantList();
      setTimeout(() => {
        this.isSliding = false;
      }, 500);
    },
    //跳转到咨询师详情
    goToConsultantDetail(id) {
      this.$router.push({ 
        path: `/expert-detail/${id}`
      })
    },
    //处理图片加载错误
    handleImageError(e) {
      e.target.src = 'https://picsum.photos/160/160?random=' + Math.random();
    },
    //跳转到详情页
    goToDetail(item) {
      if (item.id) {
        this.$router.push({
          path: `/detailHome/${item.id}`
        });
      }
    },
    //格式化日期为 MM-DD 格式
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}-${day}`;
    },
    // 轮播图效果
    banner() {
      new Swiper(this.$refs.mySwiper, {
        direction: 'horizontal',
        loop: true,
        loopAdditionalSlides: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observeParents: false,
        observer: true,
        speed: 1000,
        centeredSlides: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    }
  },
  watch: {
    index_banner: {
      handler: function () {
        this.$nextTick(() => {
          this.banner()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .swiper-banner {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    height: 480px;
    overflow: hidden;
    
    :deep(.swiper-slide) {
      img {
        width: 100%;
        height: 480px;
        object-fit: cover;
      }
    }
    
    :deep(.swiper-pagination) {
      bottom: 20px;
      
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 0.5);
        opacity: 1;
        
        &.swiper-pagination-bullet-active {
          background: #fff;
          width: 30px;
          border-radius: 5px;
        }
      }
    }
  }

  .hot-news {
     background: linear-gradient(to bottom, #f5fbfd, #e8f4f8);
    width: 100%;
    height: 110px;
    .container-box {
      width: 100%;
      padding: 0;
    }
    
    .hot-box {
      display: flex;
      align-items: stretch;
      height: 110px;
      position: relative;
      
      .left {
        width: 20%;
        background: #1ca7ec;
        color: #fff;
        font-size: 1.2rem;
        font-weight: normal;
        padding: 0 50px 0 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 200px;
        flex-shrink: 0;
        position: relative;
        border-radius: 8px;
        
        &::after {
          content: '';
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 30px 0 30px 30px;
          border-color: transparent transparent transparent rgb(93,180,223);
          z-index: 2;
        }
      }
      
      .right {
        // flex: 1;
        padding: 0 40px 0 60px;
        display: flex;
        align-items: center;
        // background: linear-gradient(to bottom, #f5fbfd, #e8f4f8);
                    width: 70%;
        position: relative;
        z-index: 1;
        a {
          text-decoration: none;
          display: block;
          width: 100%;
          
          .title {
                            font-size: 0.95rem;
            color: #333;
            font-weight: normal;
            margin: 0;
            line-height: 1.5;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            transition: color 0.3s
          }
          
          .summary {
            font-size: .75rem;
            color: #666;
            margin-top: 5px;
            line-height: 1.4;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .numMod{display: flex;align-items: center;margin-bottom:8px;
    .item{display: flex;align-items: center;margin-right:14px;
      img{margin-right: 7px;}
      span{height:12px; font-size: 12px;color:#666;font-family: "DIN";font-weight: 700;}
    }        
  }
  .authorMod{display: flex;align-items: center;
    .tx{width: 22px;height: 22px;margin-right:5px;}
    span{font-size: 14px;color:#333;margin-right:5px;}
    .mark{width: 14px;height: 14px;}
  }

  .news-tabs-section {
    padding: 40px 0;
    background: #fff;
    
    .news-content-wrapper {
      display: flex;
      gap: 30px;
      align-items: flex-start;
      
      .news-left {
        flex: 0 0 440px;
        max-width: 560px;
        
        .featured-news {
          a {
            display: block;
            text-decoration: none;
            
            .featured-image {
              position: relative;
              width: 100%;
              max-width: 560px;
              height: 340px;
              border-radius: 8px;
              overflow: hidden;
              
              img {
                aspect-ratio: 4 / 2.5;
                width: 100%;
                object-fit: cover;
                transition: all 0.3s;
              }
              
              .time-badge {
                position: absolute;
                bottom: 15px;
                right: 15px;
                background: rgba(28, 167, 236, 0.9);
                color: #fff;
                padding: 8px 16px;
                border-radius: 4px;
                font-size: 0.85rem;
                font-weight: 500;
                font-family: "DIN", sans-serif;
              }
            }
            
            .featured-title {
              font-size: 0.95rem;
              color: #333;
              font-weight: 500;
              margin-top: 15px;
              line-height: 1.6;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: color 0.3s;
            }
            
            .featured-desc {
              font-size: 0.75rem;
              color: #666;
              line-height: 1.8;
              margin-top: 8px;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            
            &:hover {
              .featured-image img {
                transform: scale(1.05);
              }
              
              .featured-title {
                color: #1ca7ec;
              }
            }
          }
        }
      }
      
      .news-right {
        flex: 1;
        min-width: 0;
        
        .news-tabs {
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
          width: 100%;
          height: 100%;
          
          .tabs-header {
            display: flex;
            border-bottom: 2px solid #f0f0f0;
            
            .tab-item {
              flex: 1;
              text-align: center;
              padding: 15px 0;
              font-size: 0.95rem;
              color: #666;
              cursor: pointer;
              position: relative;
              transition: all 0.3s;
              
              &.active {
                color: #1ca7ec;
                font-weight: 500;
                background: #f8fcff;
                
                &::after {
                  content: '';
                  position: absolute;
                  bottom: -2px;
                  left: 50%;
                  transform: translateX(-50%);
                  width: 60px;
                  height: 3px;
                  background: #1ca7ec;
                }
              }
              
              &:hover {
                color: #1ca7ec;
              }
            }
          }
          
          .tabs-content {
            padding: 20px 30px;
            min-height: 280px;
            
            .tab-pane {
              width: 100%;
            }
            
            .news-list {
              list-style: none;
              padding: 0;
              margin: 0;
              width: 100%;
              
              li {
                border-bottom: 1px dashed #e5e5e5;
                width: 100%;
                
                &:last-child {
                  border-bottom: none;
                }
                
                a {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 15px 0;
                  text-decoration: none;
                  transition: all 0.3s;
                  width: 100%;
                  box-sizing: border-box;
                  
                  &:hover {
                    padding-left: 10px;
                    padding-right: 0;
                    
                    .news-title {
                      color: #1ca7ec;
                    }
                  }
                  
                  .news-title {
                    flex: 1;
                    font-size: 0.8rem;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding-right: 20px;
                    transition: color 0.3s;
                    min-width: 0;
                  }
                  
                  .news-date {
                    font-size: 0.7rem;
                    color: #999;
                    font-family: "DIN", sans-serif;
                    flex-shrink: 0;
                    width: 80px;
                    text-align: right;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .member-service-section {
    padding: 50px 0;
    
    .member-right {
      display: flex;
      gap: 20px;
      justify-content: center;
      
      .member-card {
        flex: 0 0 auto;
        
        a {
          display: flex;
          text-decoration: none;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          height: 122px;
          
          .card-left {
            background: #1ca7ec;
            padding: 15px 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            text-align: left;
            min-width: 150px;
            transition: all 0.3s ease;
            
            h3 {
              font-size: 0.95rem;
              color: #fff;
              font-weight: 500;
              margin: 0 0 5px 0;
              line-height: 1.2;
              transition: transform 0.3s ease;
            }
            
            .en-text {
              font-size: 0.55rem;
              color: rgba(255, 255, 255, 0.9);
              margin: 0;
              line-height: 1.2;
              transition: transform 0.3s ease;
            }
          }
          
          .card-right {
            background: linear-gradient(to right, #b8dce8 0%, #d4ebf2 100%);
            width: 245px;
            height: 122px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            overflow: hidden;
            position: relative;
            
            .card-icon {
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
              transition: transform 0.4s ease;
            }
          }
          
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 4px 15px rgba(28, 167, 236, 0.2);
            
            .card-left {
              background: #1890d5;
              
              h3 {
                transform: translateX(5px);
              }
              
              .en-text {
                transform: translateX(5px);
              }
            }
            
            .card-right {
              .card-icon {
                transform: scale(1.1);
              }
            }
          }
        }
      }
    }
  }

  .association-intro-section {
    background: url('~@/assets/images/aboutbg.jpg') no-repeat center center;
    background-size: cover;
    padding: 60px 0;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    
    .intro-content {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      
      .intro-left {
        flex: 1;
        max-width: 900px;
        
        .section-title {
          font-size: 1.2rem;
          color: #0f72b8;
          font-weight: 500;
          margin: 0 0 20px 0;
          display: flex;
          align-items: baseline;
          gap: 15px;
          
          .title-text {
            display: flex;
            align-items: baseline;
            gap: 15px;
          }
          
          .en-subtitle {
            font-size: 0.75rem;
            color: #999;
            font-weight: normal;
          }
          
          .more-btn-mobile {
            display: none;
          }
        }
        
        .intro-text {
          font-size: 0.55rem;
          color: #555;
          line-height: 1.8;
          margin: 0 0 40px 0;
          text-align: justify;
        }
        
        .intro-cards {
          display: flex;
          gap: 30px;
          
          .intro-card {
            flex: 1;
            background: #fff;
            border-radius: 8px;
            padding: 25px 20px;
            text-align: center;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            cursor: pointer;
            
            .card-icon {
              width: 60px;
              height: 60px;
              margin: 0 auto 15px;
              
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            
            .card-title {
              font-size: 0.95rem;
              color: #333;
              font-weight: 500;
              margin: 0 0 8px 0;
            }
            
            .card-subtitle {
              font-size: 0.7rem;
              color: #1ca7ec;
              margin: 0 0 5px 0;
            }
            
            .card-desc {
              font-size: 0.6rem;
              color: #999;
              margin: 0;
            }
            
            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 4px 20px rgba(28, 167, 236, 0.15);
            }
          }
        }
      }
      
      .intro-right {
        padding-top: 10px;
        
        .more-btn {
          display: inline-block;
          background: #118dca;
          color: #fff;
          padding: 10px 25px;
          border-radius: 20px;
          text-decoration: none;
          font-size: 0.8rem;
          transition: all 0.3s ease;
          white-space: nowrap;
          
          &:hover {
            background: #1890d5;
            transform: translateX(5px);
          }
        }
      }
    }
  }

  .education-policy-section {
    padding: 50px 0;
    background: #f8f8f8;
    
    .section-wrapper {
      display: flex;
      gap: 30px;
      
      .section-item {
        flex: 1;
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        
        .section-header {
          background: #ececec;
          height: 55px;
          padding: 0 30px 0 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          
          .section-title {
            background: url('~@/assets/images/menubg.png') no-repeat left center;
            background-size: auto 100%;
            height: 55px;
            min-width: 282px;
            font-size: 0.75rem;
            color: #fff;
            font-weight: 500;
            margin: 0;
            display: flex;
            align-items: center;
            padding-left: 30px;
          }
          
          .more-link {
            font-size: 0.45rem;
            color: #666;
            text-decoration: none;
            transition: color 0.3s;
            
            &:hover {
              color: #1ca7ec;
            }
          }
        }
        
        .section-content {
          padding: 20px 30px;
          
          .content-list {
            list-style: none;
            padding: 0;
            margin: 0;
            
            li {
              border-bottom: 1px dashed #e5e5e5;
              
              &:last-child {
                border-bottom: none;
              }
              
              a {
                display: flex;
                align-items: center;
                padding: 15px 0;
                text-decoration: none;
                transition: all 0.3s;
                
                &:hover {
                  padding-left: 10px;
                  
                  .list-title {
                    color: #1ca7ec;
                  }
                }
                
                .list-icon {
                  font-size: 0.45rem;
                  color: #1ca7ec;
                  margin-right: 10px;
                  flex-shrink: 0;
                }
                
                .list-title {
                  flex: 1;
                  font-size: 0.6rem;
                  color: #333;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  padding-right: 15px;
                  transition: color 0.3s;
                }
                
                .list-date {
                  font-size: 0.55rem;
                  color: #999;
                  font-family: "DIN", sans-serif;
                  flex-shrink: 0;
                }
              }
            }
          }
        }
      }
    }
  }

  .consultant-section {
    padding: 50px 0;
    background: #fff;
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      
      .section-title {
        font-size: 1.2rem;
        color: #0f72b8;
        font-weight: 500;
        margin: 0;
        display: flex;
        align-items: baseline;
        gap: 15px;
        
        .en-subtitle {
          font-size: 0.75rem;
          color: #999;
          font-weight: normal;
        }
      }
      
      .more-btn {
        display: inline-block;
        background: #1ca7ec;
        color: #fff;
        padding: 8px 20px;
        border-radius: 20px;
        text-decoration: none;
        font-size: 0.7rem;
        transition: all 0.3s ease;
        
        &:hover {
          background: #1890d5;
          transform: translateX(5px);
        }
      }
    }
    
    .consultant-empty {
      text-align: center;
      padding: 60px 20px;
      color: #999;
      font-size: 0.85rem;
      background: #f8f8f8;
      border-radius: 12px;
      margin-bottom: 30px;
      
      p {
        margin: 0;
      }
    }
    
    .consultant-list {
      margin-bottom: 30px;
      overflow: hidden;
      
      .consultant-wrapper {
        display: flex;
        gap: 20px;
        position: relative;
      }
      
      .consultant-card {
        flex: 0 0 calc(25% - 15px);
        background: #f8f8f8;
        border-radius: 12px;
        padding: 30px 20px 25px;
        text-align: center;
        transition: all 0.3s ease;
        position: relative;
        cursor: pointer;
        
        .consultant-avatar {
          width: 160px;
          height: 160px;
          margin: 0 auto 20px;
          border-radius: 50%;
          overflow: hidden;
          border: 5px solid #fff;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        
        .consultant-info {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin-bottom: 20px;
        }
        
        .consultant-name {
          font-size: 0.95rem;
          color: #333;
          font-weight: 600;
          margin: 0;
          letter-spacing: 1px;
        }
        
        .consultant-title {
          font-size: 0.6rem;
          color: #666;
          margin: 0;
          font-weight: normal;
        }
        
        .consultant-desc {
          font-size: 0.55rem;
          color: #666;
          line-height: 1.8;
          margin: 0;
          background: #fff;
          border-radius: 8px;
          border-top: 3px solid #1ca7ec;
          text-align: left;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-word;
        }
        
        &:hover {
          transform: translateY(-8px);
          
          .consultant-avatar {
            border-color: #1ca7ec;
          }
        }
      }
    }
    
    .consultant-nav {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      
      .page-indicator {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: "DIN", sans-serif;
        font-size: 0.85rem;
        color: #666;
        
        .current-page {
          font-weight: 600;
          color: #1ca7ec;
          font-size: 1.0rem;
        }
        
        .separator {
          color: #ccc;
        }
        
        .total-pages {
          color: #999;
        }
      }
      
      .nav-arrow {
        width: 40px;
        height: 40px;
        border: 1px solid #ddd;
        background: #fff;
        border-radius: 50%;
        color: #666;
        cursor: pointer;
        transition: all 0.3s ease;
        padding: 0;
        margin: 0;
        outline: none;
        position: relative;
        
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 0.85rem;
          line-height: 1;
        }
        
        &.nav-prev::before {
          content: '←';
        }
        
        &.nav-next::before {
          content: '→';
        }
        
        &:hover:not(.disabled) {
          background: #1ca7ec;
          color: #fff;
          border-color: #1ca7ec;
          transform: scale(1.1);
        }
        
        &.disabled {
          opacity: 0.3;
          cursor: not-allowed;
          border-color: #e5e5e5;
          color: #ccc;
        }
        
        &:focus {
          outline: none;
        }
      }
    }
  }

  /* 滑动切换动画 */
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.5s ease;
  }

  .slide-enter-from {
    opacity: 0;
    transform: translateX(100px);
  }

  .slide-leave-to {
    opacity: 0;
    transform: translateX(-100px);
  }

  .slide-move {
    transition: transform 0.5s ease;
  }

  /* 移动端适配 - 优化阅读体验 */
  @media screen and (max-width: 768px) {
    /* 轮播图适配 - 全屏展示 */
    .swiper-banner {
      width: 100vw;
      margin-left: calc(-50vw + 50%);
      margin-right: calc(-50vw + 50%);
      height: 240px;
      position: relative;
      left: 0;
      right: 0;
      
      :deep(.swiper-slide) {
        img {
          height: 240px;
          object-fit: cover;
        }
      }
      
      :deep(.swiper-pagination) {
        bottom: 15px;
        
        .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          background: rgba(255, 255, 255, 0.6);
          opacity: 1;
          
          &.swiper-pagination-bullet-active {
            background: #fff;
            width: 20px;
            border-radius: 4px;
          }
        }
      }
    }

    /* 最新要闻 - 卡片式设计 */
    .hot-news {
      height: auto;
      padding: 20px 0;
      background: #f5f5f5;
      
      .container-box {
        padding: 0 15px;
      }
      
      .hot-box {
        flex-direction: column;
        height: auto;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        
        .left {
          width: 100%;
          min-width: auto;
          padding: 15px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 0;
          background: linear-gradient(135deg, #1ca7ec 0%, #1890d5 100%);
          
          &::after {
            display: none;
          }
        }
        
        .right {
          width: 100%;
          padding: 15px;
          background: #fff;
          
          a {
            .title {
              font-size: 1.05rem;
              font-weight: 600;
              white-space: normal;
              line-height: 1.6;
              margin-bottom: 10px;
              color: #222;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            
            .summary {
              font-size: 0.9rem;
              color: #666;
              white-space: normal;
              line-height: 1.7;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
    }

    /* 新闻选项卡 - 移动端优先设计 */
    .news-tabs-section {
      padding: 20px 0;
      background: #f5f5f5;
      
      .gk-container {
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .news-content-wrapper {
        flex-direction: column;
        gap: 15px;
        
        /* 特色新闻 - 大图展示 */
        .news-left {
          flex: 1;
          width: 100%;
          max-width: 100%;
          margin: 0;
          
          .featured-news {
            background: #fff;
            border-radius: 0;
            overflow: hidden;
            
            a {
              .featured-image {
                height: 200px;
                border-radius: 0;
                width: 100%;
                max-width: 100%;
                overflow: hidden;
                position: relative;
                
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  display: block;
                }
                
                .time-badge {
                  font-size: 0.85rem;
                  padding: 5px 12px;
                  bottom: 10px;
                  right: 10px;
                }
              }
              
              .featured-title {
                font-size: 1.05rem;
                font-weight: 600;
                margin: 15px 15px 8px;
                line-height: 1.6;
                color: #222;
              }
              
              .featured-desc {
                font-size: 0.9rem;
                color: #666;
                line-height: 1.7;
                margin: 0 15px 15px;
                -webkit-line-clamp: 2;
              }
            }
          }
        }
        
        /* 选项卡列表 */
        .news-right {
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          
          .news-tabs {
            background: #fff;
            border-radius: 12px;
            margin: 0;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
            width: 100%;
            
            .tabs-header {
              background: #fff;
              border-bottom: 1px solid #f0f0f0;
              
              .tab-item {
                font-size: 1rem;
                font-weight: 500;
                padding: 14px 0;
                color: #666;
                
                &.active {
                  color: #1ca7ec;
                  font-weight: 600;
                  
                  &::after {
                    width: 50px;
                    height: 3px;
                    bottom: -1px;
                  }
                }
              }
            }
            
            .tabs-content {
              padding: 0;
              
              .tab-pane {
                width: 100%;
              }
              
              .news-list {
                width: 100%;
                
                li {
                  border-bottom: 1px solid #f5f5f5;
                  width: 100%;
                  
                  &:last-child {
                    border-bottom: none;
                  }
                  
                  a {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    width: 100%;
                    box-sizing: border-box;
                    
                    &:hover {
                      background: #f8f8f8;
                      padding: 15px 15px 15px 20px;
                    }
                    
                    .news-title {
                      font-size: 0.95rem;
                      color: #333;
                      line-height: 1.6;
                      margin-bottom: 8px;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      white-space: normal;
                      padding-right: 0;
                      width: 100%;
                      word-break: break-word;
                    }
                    
                    .news-date {
                      font-size: 0.8rem;
                      color: #999;
                      display: block;
                      width: auto;
                      text-align: left;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    /* 会员服务 - 垂直卡片布局 */
    .member-service-section {
      padding: 20px 0;
      background: #fff;
      
      .gk-container {
        padding: 0 15px;
      }
      
      .member-right {
        flex-direction: column;
        gap: 12px;
        padding: 0;
        
        .member-card {
          width: 100%;
          
          a {
            height: auto;
            flex-direction: row;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
            border-radius: 12px;
            overflow: hidden;
            background: linear-gradient(135deg, #1ca7ec 0%, #1890d5 100%);
            
            .card-left {
              width: 100%;
              padding: 20px 20px;
              flex: 1;
              background: transparent;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              text-align: center;
              
              h3 {
                font-size: 1.15rem;
                font-weight: 600;
                margin-bottom: 8px;
                color: #fff;
              }
              
              .en-text {
                font-size: 0.75rem;
                line-height: 1.4;
                color: rgba(255, 255, 255, 0.9);
              }
            }
            
            .card-right {
              display: none;
            }
            
            &:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 16px rgba(28, 167, 236, 0.3);
              background: linear-gradient(135deg, #1890d5 0%, #0f72b8 100%);
            }
          }
        }
      }
    }

    /* 协会介绍 - 移动端优化 */
    .association-intro-section {
      padding: 20px 0;
      background-size: cover;
      background-position: center;
      
      &::before {
        background: rgba(255, 255, 255, 0.95);
      }
      
      .gk-container {
        padding: 0 15px;
      }
      
      .intro-content {
        flex-direction: column;
        gap: 20px;
        
        .intro-left {
          .section-title {
            font-size: 1.2rem;
            font-weight: 600;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            margin-bottom: 15px;
            
            .title-text {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 5px;
              flex: 1;
            }
            
            .en-subtitle {
              font-size: 0.8rem;
              color: #999;
            }
            
            .more-btn-mobile {
              display: inline-block;
              background: #118dca;
              color: #fff;
              padding: 8px 20px;
              border-radius: 15px;
              text-decoration: none;
              font-size: 0.85rem;
              transition: all 0.3s ease;
              white-space: nowrap;
              flex-shrink: 0;
              
              &:hover {
                background: #1890d5;
              }
            }
          }
          
          .intro-text {
            font-size: 0.9rem;
            line-height: 1.8;
            color: #555;
            margin-bottom: 20px;
            text-align: justify;
          }
          
          .intro-cards {
            flex-direction: column;
            gap: 12px;
            
            .intro-card {
              padding: 15px;
              display: flex;
              flex-direction: row;
              align-items: center;
              text-align: left;
              background: rgba(255, 255, 255, 0.95);
              
              .card-icon {
                width: 50px;
                height: 50px;
                margin: 0 15px 0 0;
                flex-shrink: 0;
              }
              
              .card-title {
                font-size: 1rem;
                margin-bottom: 4px;
              }
              
              .card-subtitle {
                font-size: 0.75rem;
                margin-bottom: 2px;
              }
              
              .card-desc {
                display: none;
              }
              
              &:hover {
                transform: translateX(5px);
              }
            }
          }
        }
        
        .intro-right {
          display: none;
        }
      }
    }

    /* 教育培训/政策法规 - 卡片式布局 */
    .education-policy-section {
      padding: 20px 0;
      background: #f5f5f5;
      
      .gk-container {
        padding: 0 15px;
      }
      
      .section-wrapper {
        flex-direction: column;
        gap: 15px;
        
        .section-item {
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          
          .section-header {
            height: auto;
            padding: 15px;
            background: linear-gradient(135deg, #1ca7ec 0%, #1890d5 100%);
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-radius: 12px 12px 0 0;
            
            .section-title {
              background: none;
              height: auto;
              min-width: auto;
              font-size: 1rem;
              font-weight: 600;
              color: #fff;
              padding: 0;
            }
            
            .more-link {
              font-size: 0.8rem;
              color: rgba(255, 255, 255, 0.9);
              
              &:hover {
                color: #fff;
              }
            }
          }
          
          .section-content {
            padding: 0;
            
            .content-list {
              li {
                border-bottom: 1px solid #f5f5f5;
                
                &:last-child {
                  border-bottom: none;
                }
                
                a {
                  padding: 15px;
                  display: block;
                  
                  &:hover {
                    background: #f8f8f8;
                    padding-left: 15px;
                  }
                  
                  .list-icon {
                    display: none;
                  }
                  
                  .list-title {
                    font-size: 0.95rem;
                    color: #333;
                    line-height: 1.6;
                    margin-bottom: 8px;
                    display: block;
                    white-space: normal;
                    padding-right: 0;
                  }
                  
                  .list-date {
                    font-size: 0.8rem;
                    color: #999;
                    display: block;
                  }
                }
              }
            }
          }
        }
      }
    }

    /* 咨询师查询 - 卡片式展示 */
    .consultant-section {
      padding: 20px 0;
      background: #fff;
      
      .section-header {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
        padding: 0 15px;
        
        .section-title {
          font-size: 1.2rem;
          font-weight: 600;
          flex-direction: column;
          align-items: flex-start;
          gap: 5px;
          
          .en-subtitle {
            font-size: 0.8rem;
          }
        }
        
        .more-btn {
          padding: 8px 20px;
          font-size: 0.85rem;
          white-space: nowrap;
        }
      }
      
      .consultant-list {
        margin-bottom: 20px;
        padding: 0 15px;
        
        .consultant-wrapper {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
        }
        
        .consultant-card {
          padding: 20px 15px;
          background: #fff;
          border: 1px solid #f0f0f0;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          
          .consultant-avatar {
            width: 80px;
            height: 80px;
            margin: 0 0 15px 0;
            border-width: 3px;
            flex-shrink: 0;
          }
          
          .consultant-info {
            flex-direction: column;
            align-items: center;
            gap: 5px;
            margin-bottom: 10px;
            flex: 1;
            width: 100%;
          }
          
          .consultant-name {
            font-size: 1.05rem;
            font-weight: 600;
          }
          
          .consultant-title {
            font-size: 0.8rem;
            color: #1ca7ec;
          }
          
          .consultant-desc {
            font-size: 0.85rem;
            line-height: 1.6;
            padding: 0;
            background: none;
            border: none;
            color: #666;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            margin-top: 8px;
            width: 100%;
            word-break: break-word;
          }
          
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            
            .consultant-avatar {
              border-color: #1ca7ec;
            }
          }
        }
      }
      
      .consultant-nav {
        display: flex;
        padding: 0 15px;
        
        .page-indicator {
          font-size: 0.9rem;
          
          .current-page {
            font-size: 1.1rem;
          }
        }
        
        .nav-arrow {
          width: 36px;
          height: 36px;
          
          &::before {
            font-size: 0.9rem;
          }
        }
      }
    }

    /* 内容选项卡 - 移动端优化 */
    .container-tabs {
      padding: 20px 0;
      background: #fff;
      
      .tabs-nav {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        margin-bottom: 15px;
        
        &::-webkit-scrollbar {
          display: none;
        }
        
        ul {
          display: flex;
          flex-wrap: nowrap;
          justify-content: flex-start;
          padding: 0 15px;
          margin: 0;
          min-width: max-content;
          
          li {
            flex-shrink: 0;
            margin-right: 8px;
            margin-bottom: 0;
            
            a {
              font-size: 0.9rem;
              padding: 8px 16px;
              white-space: nowrap;
              display: inline-block;
              border-radius: 20px;
              background: #f5f5f5;
              color: #666;
              text-decoration: none;
              transition: all 0.3s;
              
              &.active {
                background: #1ca7ec;
                color: #fff;
                font-weight: 600;
              }
              
              &:hover {
                background: #1ca7ec;
                color: #fff;
              }
            }
          }
        }
      }
      
      .tabs-box-cont {
        padding: 0 15px;
        
        .tabs-box {
          :deep(ul) {
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 0;
            margin: 0;
            
            li {
              width: 100% !important;
              float: none;
              background: #fff;
              border-radius: 12px;
              overflow: hidden;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
              transition: all 0.3s;
              
              &:hover {
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                transform: translateY(-2px);
              }
              
              .pic {
                height: 180px;
                width: 100%;
                overflow: hidden;
                background: #f5f5f5;
                
                a {
                  display: block;
                  height: 100%;
                  
                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                  }
                }
                
                &:hover img {
                  transform: scale(1.05);
                }
              }
              
              h3 {
                font-size: 1rem;
                font-weight: 600;
                line-height: 1.5;
                padding: 12px 15px 8px;
                margin: 0;
                
                a {
                  color: #222;
                  text-decoration: none;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  
                  &:hover {
                    color: #1ca7ec;
                  }
                }
              }
              
              .tags {
                padding: 0 15px 8px;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                
                span {
                  font-size: 0.7rem;
                  padding: 3px 8px;
                  margin: 0;
                  display: inline-block;
                  background: #f0f0f0;
                  color: #666;
                  border-radius: 3px;
                }
              }
              
              .numMod {
                padding: 0 15px 8px;
                
                .item {
                  margin-right: 12px;
                  
                  img {
                    width: 14px;
                    height: 14px;
                  }
                  
                  span {
                    font-size: 11px;
                  }
                }
              }
              
              .authorMod {
                padding: 0 15px 12px;
                border-top: 1px solid #f5f5f5;
                padding-top: 10px;
                margin-top: 2px;
                
                .tx {
                  width: 22px;
                  height: 22px;
                  border-radius: 50%;
                }
                
                span {
                  font-size: 13px;
                  color: #666;
                }
                
                .mark {
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 480px) {
    /* 轮播图 */
    .swiper-banner {
      width: 100vw;
      margin-left: calc(-50vw + 50%);
      margin-right: calc(-50vw + 50%);
      height: 200px;
      
      :deep(.swiper-slide) {
        img {
          height: 200px;
        }
      }
    }

    /* 最新要闻 */
    .hot-news {
      padding: 15px 0;
      
      .container-box {
        padding: 0 10px;
      }
      
      .hot-box {
        .left {
          font-size: 0.95rem;
          padding: 12px;
        }
        
        .right {
          padding: 12px;
          
          a {
            .title {
              font-size: 1rem;
              margin-bottom: 8px;
            }
            
            .summary {
              font-size: 0.85rem;
              line-height: 1.6;
            }
          }
        }
      }
    }

    /* 新闻选项卡 */
    .news-tabs-section {
      padding: 15px 0;
      
      .gk-container {
        width: 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .news-content-wrapper {
        gap: 12px;
        
        .news-left {
          width: 100%;
          max-width: 100%;
          margin: 0;
          
          .featured-news {
            background: #fff;
            
            a {
              .featured-image {
                height: 180px;
                width: 100%;
                max-width: 100%;
                overflow: hidden;
                
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  display: block;
                }
                
                .time-badge {
                  font-size: 0.8rem;
                  padding: 4px 10px;
                }
              }
              
              .featured-title {
                font-size: 1rem;
                margin: 12px 10px 6px;
              }
              
              .featured-desc {
                font-size: 0.85rem;
                margin: 0 10px 12px;
              }
            }
          }
        }
        
        .news-right {
          padding: 0 10px;
          
          .news-tabs {
            margin: 0;
            
            .tabs-header {
              .tab-item {
                font-size: 0.95rem;
                padding: 12px 0;
              }
            }
            
            .tabs-content {
              .news-list {
                li {
                  a {
                    padding: 12px;
                    
                    &:hover {
                      background: #f8f8f8;
                      padding: 12px 12px 12px 16px;
                    }
                    
                    .news-title {
                      font-size: 0.9rem;
                      margin-bottom: 6px;
                    }
                    
                    .news-date {
                      font-size: 0.75rem;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    /* 会员服务 */
    .member-service-section {
      padding: 15px 0;
      
      .gk-container {
        padding: 0 10px;
      }
      
      .member-right {
        gap: 10px;
        
        .member-card {
          a {
            background: linear-gradient(135deg, #1ca7ec 0%, #1890d5 100%);
            
            .card-left {
              width: 100%;
              padding: 18px 15px;
              
              h3 {
                font-size: 1.05rem;
                margin-bottom: 6px;
              }
              
              .en-text {
                font-size: 0.7rem;
              }
            }
            
            .card-right {
              display: none;
            }
          }
        }
      }
    }

    /* 协会介绍 */
    .association-intro-section {
      padding: 15px 0;
      
      .gk-container {
        padding: 0 10px;
      }
      
      .intro-content {
        gap: 15px;
        
        .intro-left {
          .section-title {
            font-size: 1.1rem;
            margin-bottom: 12px;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            
            .title-text {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 3px;
              flex: 1;
            }
            
            .en-subtitle {
              font-size: 0.75rem;
            }
            
            .more-btn-mobile {
              display: inline-block;
              background: #118dca;
              color: #fff;
              padding: 6px 16px;
              border-radius: 12px;
              text-decoration: none;
              font-size: 0.8rem;
              transition: all 0.3s ease;
              white-space: nowrap;
              flex-shrink: 0;
              
              &:hover {
                background: #1890d5;
              }
            }
          }
          
          .intro-text {
            font-size: 0.85rem;
            line-height: 1.7;
            margin-bottom: 15px;
          }
          
          .intro-cards {
            gap: 10px;
            
            .intro-card {
              padding: 12px;
              
              .card-icon {
                width: 45px;
                height: 45px;
                margin-right: 12px;
              }
              
              .card-title {
                font-size: 0.95rem;
                margin-bottom: 3px;
              }
              
              .card-subtitle {
                font-size: 0.7rem;
              }
            }
          }
        }
        
        .intro-right {
          display: none;
        }
      }
    }

    /* 教育培训/政策法规 */
    .education-policy-section {
      padding: 15px 0;
      
      .gk-container {
        padding: 0 10px;
      }
      
      .section-wrapper {
        gap: 12px;
        
        .section-item {
          .section-header {
            padding: 12px;
            
            .section-title {
              font-size: 0.95rem;
            }
            
            .more-link {
              font-size: 0.75rem;
            }
          }
          
          .section-content {
            .content-list {
              li {
                a {
                  padding: 12px;
                  
                  .list-title {
                    font-size: 0.9rem;
                    margin-bottom: 6px;
                  }
                  
                  .list-date {
                    font-size: 0.75rem;
                  }
                }
              }
            }
          }
        }
      }
    }

    /* 咨询师查询 */
    .consultant-section {
      padding: 15px 0;
      
      .section-header {
        margin-bottom: 12px;
        padding: 0 10px;
        
        .section-title {
          font-size: 1.1rem;
          
          .en-subtitle {
            font-size: 0.75rem;
          }
        }
        
        .more-btn {
          padding: 6px 15px;
          font-size: 0.8rem;
        }
      }
      
      .consultant-list {
        gap: 10px;
        padding: 0 10px;
        
        .consultant-card {
          padding: 15px 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          
          .consultant-avatar {
            width: 90px;
            height: 90px;
            margin: 0 0 12px 0;
            border-width: 3px;
          }
          
          .consultant-info {
            width: 100%;
            flex-direction: column;
            align-items: center;
            gap: 5px;
            margin-bottom: 10px;
          }
          
          .consultant-name {
            font-size: 1.05rem;
          }
          
          .consultant-title {
            font-size: 0.8rem;
          }
          
          .consultant-desc {
            font-size: 0.85rem;
            line-height: 1.6;
            margin-top: 8px;
            text-align: center;
            width: 100%;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
          }
        }
      }
    }

    /* 内容选项卡 */
    .container-tabs {
      padding: 15px 0;
      
      .tabs-nav {
        margin-bottom: 12px;
        
        ul {
          padding: 0 10px;
          
          li {
            margin-right: 6px;
            
            a {
              font-size: 0.85rem;
              padding: 6px 12px;
            }
          }
        }
      }
      
      .tabs-box-cont {
        padding: 0 10px;
        
        .tabs-box {
          :deep(ul) {
            gap: 10px;
            
            li {
              .pic {
                height: 160px;
              }
              
              h3 {
                font-size: 0.95rem;
                padding: 10px 12px 6px;
              }
              
              .tags {
                padding: 0 12px 6px;
                gap: 4px;
                
                span {
                  font-size: 0.65rem;
                  padding: 2px 6px;
                }
              }
              
              .numMod {
                padding: 0 12px 6px;
                
                .item {
                  margin-right: 10px;
                  
                  img {
                    width: 12px;
                    height: 12px;
                    margin-right: 4px;
                  }
                  
                  span {
                    font-size: 10px;
                  }
                }
              }
              
              .authorMod {
                padding: 8px 12px;
                
                .tx {
                  width: 20px;
                  height: 20px;
                  margin-right: 4px;
                }
                
                span {
                  font-size: 12px;
                }
                
                .mark {
                  width: 12px;
                  height: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss">
/* 全局容器移动端适配 - 非 scoped 样式确保覆盖全局 CSS */
@media screen and (max-width: 1440px) {
  .gk-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 20px !important;
    box-sizing: border-box !important;
  }
}

@media screen and (max-width: 768px) {
  .gk-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 15px !important;
    box-sizing: border-box !important;
  }
}

@media screen and (max-width: 480px) {
  .gk-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 10px !important;
    box-sizing: border-box !important;
  }
}
</style>
